import * as React from 'react';

export interface InstructionItemProps {
  icon: string; // Changed from ReactNode to string to accept the SVG path
  title: string;
  description: string;
}

/**
 * InstructionItem Component
 *
 * Displays a feature instruction with an icon and text.
 * Expects 'icon' to be an image source string (URL/import).
 */
export const InstructionItem: React.FC<InstructionItemProps> = ({ icon, title, description }) => (
  <div className='flex items-start gap-3'>
    {/* Icon Container */}
    <div className='mt-0.5 flex size-[40px] shrink-0 items-center justify-center'>
      <img src={icon} alt='' className='size-full object-contain' loading='lazy' />
    </div>

    {/* Text Content */}
    <div className='flex flex-col'>
      <span className='font-sans text-20 font-medium leading-27 text-dark-100'>{title}</span>
      <span className='font-sans text-14 font-normal leading-20 text-brand-800'>{description}</span>
    </div>
  </div>
);
